import {
	updateCurrentUser
} from "./login.types";
import { getCurrentUserFromStorage, setCurrentUserToStorage } from "src/utils/localStorage";

const prevUser = getCurrentUserFromStorage();

const INITIAL_STATE = {
	currentUser: prevUser
};
const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case updateCurrentUser:
      setCurrentUserToStorage(action.payload);
      return {
        ...state,
        currentUser: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
